<template>
    <div class="login">
        <van-row>
            <van-col span="24">
                <div class="dk-banner">
                    <img src="@/assets/banner_jia.png" alt="" style="height: 100%;width: 100%;">
                </div>
            </van-col>
        </van-row>
        <div>
            <van-cell-group style="margin-top: 60px;" :border="false">
                <!-- 输入手机号，调起手机号键盘 -->
                <van-row type="flex" justify="center">
                    <van-col span="20">
                        <van-field
                                :class="height_light_phone?'dk-border':'dk-border-empty'"
                                v-model="phone"
                                center
                                clearable
                                type="tel"
                                :left-icon="height_light_phone?img_phone:img_phone_empty"
                                placeholder="请输入手机号"
                                @focus="height_light_phone = true"
                                @blur="height_light_phone = false"
                                :disabled="isPhone()"
                        ></van-field>
                    </van-col>
                </van-row>

                <!-- 允许输入整数，调起数字键盘 -->
                <van-row type="flex" justify="center" align="center" style="margin-top: 40px" v-if="!isPhone()">
                    <van-col span="20">
                        <van-field
                                v-model="code"
                                maxlength="6"
                                type="digit"
                                :left-icon="height_light_code?img_code:img_code_empty"
                                placeholder="请输入验证码"
                                @focus="height_light_code = true"
                                @blur="height_light_code = false"
                                :class="height_light_code?'dk-border':'dk-border-empty'">
                            <van-button
                                    :disabled="state.smsSendBtn"
                                    slot="button"
                                    size="small"
                                    type="default"
                                    @click="sendCode"
                                    style="border:none"
                                    class="dk-button "
                                    :plain="true"
                                    :color="height_light_code?'#0177FF':''"
                                    :class="state.smsSendBtn&&'dk-color'">
                                {{!state.smsSendBtn && '获取验证码' || ('重发 '+state.time+' s')}}
                            </van-button>
                        </van-field>
                    </van-col>
                </van-row>

            </van-cell-group>
            <van-row type="flex" justify="center">
                <van-col span="20">
                    <van-button
                            :loading="loading"
                            type="small"
                            size="large"
                            :disabled="!isMobile(phone) || isPhone()"
                            :color="!isMobile(phone) || isPhone() || !code ? '#DDDDDD' : '#0177FF'"
                            @click="login"
                            :text="isPhone() ? '已绑定' : '绑定手机号'"
                            style="height:47px;margin-top: 48px;border-radius: 47px;font-size: 16px;border-width: 0">

                    </van-button>
                </van-col>
            </van-row>

            <van-row type="flex" justify="center">
                <a @click="openEdit" class="edit-phone">
                    修改手机号
                </a>
            </van-row>
            <van-row type="flex" justify="center">
                <a @click="loginOut" class="dk-loginout">
                    退出登录
                </a>
            </van-row>
        </div>

        <van-row>
            <van-col span="24">
                <div class="dk-qrcode">
                    <img src="@/assets/qrcode_jia.png" alt="" style="height: 100%;width: 100%">
                </div>
            </van-col>
        </van-row>

        <!--修改手机号弹出框-->
        <van-dialog
                v-model="showEdit"
                title="修改手机号"
                show-cancel-button
                confirm-button-text="确认修改"
                @confirm="editPhone"
                @cancel="closeEdit">
            <van-row type="flex" justify="center">
                <van-col span="22">
                    <van-field
                            :class="height_light_phone?'dk-border-noradius':'dk-border-empty-noradius'"
                            v-model="phoneEdit"
                            center
                            clearable
                            type="tel"
                            placeholder="请输入手机号"
                            :left-icon="height_light_phone?img_phone:img_phone_empty"
                            @focus="height_light_phone = true"
                            @blur="height_light_phone = false"
                    ></van-field>
                </van-col>
            </van-row>
            <van-row type="flex" justify="center">
                <van-col span="22">
                    <van-field
                            :class="height_light_code?'dk-border-noradius':'dk-border-empty-noradius'"
                            v-model="codeEdit"
                            maxlength="6"
                            center
                            clearable
                            type="digit"
                            :left-icon="height_light_code?img_code:img_code_empty"
                            placeholder="请输入验证码"
                            @focus="height_light_code = true"
                            @blur="height_light_code = false">
                        <van-button
                                :disabled="stateEdit.smsSendBtn"
                                slot="button"
                                size="small"
                                type="default"
                                @click="sendCodeEdit"
                                style="border:none"
                                class="dk-button "
                                :plain="true"
                                :color="height_light_code?'#0177FF':''"
                                :class="stateEdit.smsSendBtn&&'dk-color'">
                            {{!stateEdit.smsSendBtn && '获取验证码' || ('重发 '+stateEdit.time+' s')}}
                        </van-button>
                    </van-field>
                </van-col>
            </van-row>
        </van-dialog>

        <!--图形验证码-->
        <van-dialog
                v-model="showSlide"
                confirmButtonText="关闭"
                :beforeClose="dialogBeforeClose"
                @confirm="closeSlide">
            <slide-verify
                    ref="slideRef"
                    :l="42"
                    :r="10"
                    :w="334"
                    :h="200"
                    :imgs="images"
                    slider-text="向右滑动完成验证"
                    @success="onSuccess"
                    @fail="onFail"
                    @refresh="onRefresh"
                    @fulfilled="onRefreshComplete"
                    @again="onAgain">
            </slide-verify>
        </van-dialog>
    </div>

</template>

<script>
    import {bindPhone,getUserOpenid,getSmsCaptcha,loginOut,getUserInfo} from '@/api/index'
    import {postAction,getAction} from '@/api/manage'
    import {Button, Cell, CellGroup, Field, Toast, Col, Row, Dialog } from 'vant';
    import {setStore, getStore,clearStore} from "@/utils/storage";
    import {isMobile} from "@/utils/validate";
    import img_phone from '@/assets/phone.png'
    import img_code from '@/assets/code.png'
    import img_phone_empty from '@/assets/phone_empty.png'
    import img_code_empty from '@/assets/code_empty.png'

    export default {
        name: "index",
        components: {
            [Button.name]: Button,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Col.name]: Col,
            [Row.name]: Row,
            [Dialog.Component.name]: Dialog.Component,
        },
        data() {
            return {
                appid: '',
                height_light_phone: false,
                height_light_code: false,
                loading: false,
                text: "登录",
                phone: '',
                phoneEdit: '',
                code: '',
                codeEdit: '',
                img_phone,
                img_phone_empty,
                img_code_empty,
                img_code,
                showEdit: false,
                state: {
                    time: 60,
                    smsSendBtn: false,
                },
                stateEdit: {
                    time: 60,
                    smsSendBtn: false,
                },
                isEdit: false,
                showSlide: false,
                images: [
                    require('@/assets/code_bg.png')
                ],
            };
        },

        created() {
            this.appid = this.$route.query.appid;
            console.log("appid====",this.appid)
            //微信授权判定
            if(this.appid) {
                if (getStore(this.appid + '_' + 'openid')) {
                    console.log("123",getStore(this.appid + '_' + 'openid'))
                    //获取用户信息
                    this.getUserInfo();
                }else{
                    console.log("微信授权")
                    this.getOpenId();
                }
            }
        },
        methods: {
            isMobile(value) {
                return isMobile(value)
            },
            isPhone(){
                return getStore(this.appid + '_' + 'phone');
            },
            //微信授权
            getOpenId() {
                var access_code = this.getUrlParam('code');//通过获取code回调的链接中的response_type=code，来获取code
                console.log("code",access_code)
                if (access_code == "" || access_code == null) {
                    var fromurl = location.href;
                    var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+ this.appid
                        +"&redirect_uri=" + encodeURIComponent(fromurl)
                        +"&response_type=code"
                        +"&scope=snsapi_userinfo"
                        +"&state=STATE#wechat_redirect";
                    // location.href = url;
                    location.replace(url);
                }else {
                    //获取用户openid
                    this.loading = true;
                    postAction(getUserOpenid, {code: access_code, appid: this.appid}).then(res => {
                        this.loading = false;
                        if (res.success) {
                            Toast(res.message);
                            //授权成功，缓存用户信息，跳转相应页面
                            setStore(this.appid + '_' + 'openid', res.result.openid);
                            if(res.result.phone){
                                this.phone = res.result.phone;
                                setStore(this.appid + '_' + 'phone', res.result.phone);
                            }
                        } else {
                            Toast(res.message);
                        }
                    }).catch(() => {
                        this.loading = false;
                    })
                }
            },
            getUrlParam(name){
                var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if (r != null) {
                    return unescape(r[2]);
                } else {
                    return null;
                }
            },
            //获取用户信息
            getUserInfo(){
                getAction(getUserInfo, {openid: getStore(this.appid + '_' + 'openid'), appid: this.appid}).then(res => {
                    if (res.success) {
                        if(res.result.phone){
                            this.phone = res.result.phone;
                            setStore(this.appid + '_' + 'phone', res.result.phone);
                        } else {
                            this.phone = '';
                            if(getStore(this.appid + '_' + 'phone')){
                                clearStore(this.appid + '_' + 'phone');
                                location. reload();
                            }
                        }
                    }else {
                        clearStore(this.appid + '_' + 'phone');
                        this.phone = '';
                    }
                })
            },
            //绑定手机号
            login() {
                if(!getStore(this.appid + '_' + 'openid')){
                    Toast('请先授权~');
                    return
                }
                if (!this.phone) {
                    Toast('请输入手机号~');
                    return
                }
                if (!this.code) {
                    Toast("请输入验证码~");
                    return;
                }
                if (!isMobile(this.phone)) {
                    Toast('手机号格式错误~');
                    return
                }
                this.loading = true;
                postAction(bindPhone, {phone: this.phone, openid: getStore(this.appid + '_' + 'openid'), appid: this.appid, code: this.code}).then(res => {
                    this.loading = false;
                    if (res.success) {
                        Dialog.alert({
                            title: '提示',
                            message: res.message,
                        }).then(() => {

                        });
                        //登录成功，缓存用户信息，跳转相应页面
                        setStore(this.appid + '_' + 'phone', res.result);
                        this.phone = res.result;
                    } else {
                        Dialog.alert({
                            title: '提示',
                            message: res.message,
                        }).then(() => {

                        });
                    }
                }).catch(() => {
                    this.loading = false;
                }).finally(() => {
                    this.code = '';
                    this.state.time = 60;
                    this.state.smsSendBtn = false;
                })
            },
            //打开弹窗
            openEdit(){
                this.showEdit = true;
                this.phoneEdit = '';
                this.codeEdit = '';
                this.stateEdit.time = 60;
                this.stateEdit.smsSendBtn = false;
            },
            closeEdit(){
                this.showEdit = false;
            },
            //修改手机号
            editPhone(){
                if(!getStore(this.appid + '_' + 'openid')){
                    Toast('请先授权~');
                    return
                }
                if (!this.phoneEdit) {
                    Toast('请输入手机号~');
                    return
                }
                if (!this.codeEdit) {
                    Toast("请输入验证码~");
                    return;
                }
                if (!isMobile(this.phoneEdit)) {
                    Toast('手机号格式错误~');
                    return
                }
                this.loading = true;
                postAction(bindPhone, {phone: this.phoneEdit, openid: getStore(this.appid + '_' + 'openid'), appid: this.appid, code: this.codeEdit}).then(res => {
                    this.loading = false;
                    if (res.success) {
                        Dialog.alert({
                            title: '提示',
                            message: res.message,
                        }).then(() => {

                        });
                        //修改成功，缓存用户信息
                        setStore(this.appid + '_' + 'phone', res.result);
                        this.phone = res.result;
                        this.showEdit = false;
                    } else {
                        Dialog.alert({
                            title: '提示',
                            message: res.message,
                        }).then(() => {

                        });
                    }
                }).catch(() => {
                    this.loading = false;
                }).finally(() => {
                    this.phoneEdit = '';
                    this.codeEdit = '';
                    this.stateEdit.time = 60;
                    this.stateEdit.smsSendBtn = false;
                })
            },
            getAuthCode(){
                this.state.smsSendBtn = true;
                let interval = window.setInterval(() => {
                    if (this.state.time-- <= 0) {
                        this.state.time = 60;
                        this.state.smsSendBtn = false;
                        window.clearInterval(interval);
                    }
                }, 1000);
                let smsParams = {};
                smsParams.phone = this.phone;
                smsParams.openid = getStore(this.appid + '_' + 'openid');
                postAction(getSmsCaptcha, smsParams)
                    .then(() => {
                        Toast('验证码已发送~')
                    })
                    .catch(() => {
                        Toast('验证码发送失败~');
                        clearInterval(interval);
                        this.state.time = 60;
                        this.state.smsSendBtn = false;
                    });
            },
            getAuthCodeEdit(){
                this.stateEdit.smsSendBtn = true;
                let interval = window.setInterval(() => {
                    if (this.stateEdit.time-- <= 0) {
                        this.stateEdit.time = 60;
                        this.stateEdit.smsSendBtn = false;
                        window.clearInterval(interval);
                    }
                }, 1000);
                let smsParams = {};
                smsParams.phone = this.phoneEdit;
                smsParams.openid = getStore(this.appid + '_' + 'openid');
                postAction(getSmsCaptcha, smsParams)
                    .then(() => {
                        Toast('验证码已发送~')
                    })
                    .catch(() => {
                        Toast('验证码发送失败~');
                        clearInterval(interval);
                        this.stateEdit.time = 60;
                        this.stateEdit.smsSendBtn = false;
                    });
            },
            //获取验证码
            sendCode() {
                if(!getStore(this.appid + '_' + 'openid')){
                    Toast('请先授权~');
                    return
                }
                if (!this.phone) {
                    Toast('请输入手机号~');
                    return;
                }
                if (!isMobile(this.phone)) {
                    Toast('手机号格式错误~');
                    return
                }
                this.showSlide = true;
                this.isEdit = false;
            },
            sendCodeEdit() {
                if(!getStore(this.appid + '_' + 'openid')){
                    Toast('请先授权~');
                    return
                }
                if (!this.phoneEdit) {
                    Toast('请输入手机号~');
                    return;
                }
                if (!isMobile(this.phoneEdit)) {
                    Toast('手机号格式错误~');
                    return
                }
                this.showSlide = true;
                this.isEdit = true;
            },
            loginOut() {
                Dialog.confirm({
                    message: '是否立即退出登录'
                }).then(() => {
                    this.loading = true;
                    postAction(loginOut, {openid: getStore(this.appid + '_' + 'openid'), appid: this.appid}).then(res => {
                        this.loading = false;
                        if (res.success) {
                            Toast(res.message);
                            clearStore(this.appid + '_' + 'phone');
                            this.phone = '';
                        } else {
                            Toast('操作失败')
                        }
                    })
                }).catch(() => {

                })
            },
            // 成功回调
            onSuccess(){
                Toast('恭喜您，验证成功啦！');
                this.showSlide = false;
                if(!this.isEdit){
                    this.getAuthCode();
                }else{
                    this.getAuthCodeEdit()
                }
                this.$refs.slideRef.reset();
            },
            // 失败回调
            onFail(){
                Toast('验证失败，请重试哦！');
            },
            // 点击刷新回调
            onRefresh(){
                this.tipsMsg = ''
            },
            // 刷新成功后回调
            onRefreshComplete(){
                // TODO
                this.tipsMsg = '';
            },
            // 检测到非人为操作
            onAgain() {
                Toast("再试一次吧～");
                this.$refs.slideRef.reset();
            },
            closeSlide(){
                this.showSlide = false;
            },
            dialogBeforeClose(action,done){
                this.$refs.slideRef.reset();
                done();
            },
        }
    }
</script>

<style scoped>
    .login {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .edit-phone{
        font-size: 16px;
        margin-top: 16px;
        color: #096dd9;
        display: flex;
        justify-content: center;
    }

    .dk-banner {
        height: 160px;

    }

    .dk-border {
        font-family: PingFangSC-Medium, PingFang SC;
        font-size: 14px;
        border: 1px solid #0177FF;
        border-radius: 47px;
        box-sizing: border-box;
    }

    .dk-border-empty {
        font-family: PingFangSC-Medium, PingFang SC;
        font-size: 14px;
        border: 1px solid #CCCCCC;
        border-radius: 47px;
        box-sizing: border-box;
    }

    .dk-border-noradius {
        font-family: PingFangSC-Medium, PingFang SC;
        font-size: 14px;
        margin: 6px 0;
        box-sizing: border-box;
    }

    .dk-border-empty-noradius {
        font-family: PingFangSC-Medium, PingFang SC;
        font-size: 14px;
        margin: 6px 0;
        box-sizing: border-box;
    }

    .dk-button {
        height: auto;
        width: auto;
        font-size: 14px;
        color: #999999;
        opacity: 1;
    }

    .dk-color {
        color: #0177FF;
    }

    .dk-join {
        font-size: 12px;
        color: #0177FF;
    }

    .dk-qrcode {
        margin-top: 90px;
        height: 135px;

    }
    .dk-loginout {
        height: 70px;
        width: 70px;
        line-height: 70px;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        border-radius: 50%;
        color: #fff;
        background: #0177FF;
        position: fixed;
        right: 15px;
        bottom: 15%;
        /*box-shadow: ;*/
    }
</style>
